<template>
  <el-tag
    class="ui-tag"
    :class="`ui-tag--${resolvedTone}`"
    :type="type || undefined"
    :style="identityStyle"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </el-tag>
</template>

<script>
export default {
  name: 'UiTag',
  inheritAttrs: false,
  props: {
    tone: {
      type: String,
      default: '',
      validator: value => ['', 'primary', 'warning', 'danger', 'accent', 'neutral'].includes(value)
    },
    // 飞机身份色仅用于区分对象，不覆盖显式状态语义。
    identityColor: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: '',
      validator: value => ['', 'success', 'warning', 'danger', 'info'].includes(value)
    }
  },
  computed: {
    identityStyle () {
      const color = this.identityColor.trim()
      if (this.tone || this.type || !/^#[0-9a-fA-F]{6}$/.test(color)) return null
      return { '--ui-tag-color': color }
    },
    resolvedTone () {
      if (this.tone) return this.tone
      return {
        success: 'primary',
        warning: 'warning',
        danger: 'danger',
        info: 'neutral'
      }[this.type] || 'primary'
    }
  }
}
</script>

<style lang="scss">
.el-tag.ui-tag {
  --ui-tag-color: var(--ui-color-primary);

  height: 24px;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
  color: var(--ui-tag-color);
  border: 1px solid var(--ui-border-color);
  border-radius: 3px;
  background: var(--ui-bg-control-elevated);
  font-family: var(--ui-font-family-sans);
  font-size: var(--ui-font-size-caption);
  font-style: normal;
  font-weight: var(--ui-font-weight-medium);
  line-height: 22px;
  letter-spacing: .1px;
  box-shadow: none;
  text-shadow: none;
  transition: none;

  &.el-tag--mini {
    height: 22px;
    min-height: 22px;
    padding: 0 6px;
    line-height: 20px;
  }

  &.el-tag--medium {
    height: 28px;
    min-height: 28px;
    padding: 0 9px;
    line-height: 26px;
  }

  &.ui-tag--warning {
    --ui-tag-color: var(--ui-color-warning);
  }

  &.ui-tag--danger {
    --ui-tag-color: var(--ui-color-danger);
  }

  &.ui-tag--accent {
    --ui-tag-color: var(--ui-color-accent);
  }

  &.ui-tag--neutral {
    --ui-tag-color: var(--ui-color-info);
  }

  .el-tag__close {
    color: currentColor;
    background: transparent;
  }

  .el-tag__close:hover {
    color: var(--ui-bg-page);
    background: var(--ui-tag-color);
  }

  .iconfont {
    color: currentColor;
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
  }

  .iconfont + * {
    margin-left: var(--ui-space-xs);
  }

  .ui-tag__text {
    min-width: 0;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .table-code {
    color: currentColor;
  }
}
</style>
